import '../../../node_modules/alertifyjs/build/css/alertify.css';
import '../../css/external/alertify.scss';
import alertify from 'alertifyjs';

export default alertify;